import {showMessage} from 'exsportia-components'
import {useCallback} from 'react'
import {useDispatch} from 'react-redux'

import {PrivateCodeModal} from '../../components/private-code-modal/private-code-modal'
import {useLocale} from '../../utils/i18n'
import {useModalActions} from '../../utils/modals'
import {checkSubscriptionPasscode} from './actions'
import {useBookingLoader} from './hooks'

export const useCheckSubscriptionPasscode = () => {
  const {l} = useLocale()
  const dispatch = useDispatch()
  const {setIsLoading} = useBookingLoader()
  const {openModal, closeModal} = useModalActions()

  const openSubscriptionPasscodeCheckModal = useCallback(
    ({
      subscriptionId,
      onSuccess,
      onReject,
    }: {
      subscriptionId: string
      onSuccess?: () => void
      onReject?: () => void
    }) => {
      if (!subscriptionId) {
        return
      }
      const handleCheckPassCode = (passCode: string) => {
        setIsLoading(true)
        dispatch(
          checkSubscriptionPasscode({
            password: passCode,
            membershipId: subscriptionId,
            callback: () => {
              closeModal()
              showMessage(l('success'), 'success')
              setIsLoading(false)
              if (onSuccess) {
                onSuccess()
              }
            },
            rejectCallback: () => {
              setIsLoading(false)
              showMessage(l('error'), 'error')
              if (onReject) {
                onReject()
              }
            },
          }),
        )
      }
      openModal({
        title: l('privateSubscription'),
        footerConfig: {
          disabled: true,
        },
        component: <PrivateCodeModal handleCheckCode={handleCheckPassCode} />,
      })
    },
    [dispatch, setIsLoading, closeModal, l, openModal],
  )

  return {
    openSubscriptionPasscodeCheckModal,
  }
}
